<template>
    <div v-if="mode == 'new'" name="Billsmodal" class="bills-modal">
        <div>
            <h1>Subir factura</h1>
        </div>
        <div class="form-group">
            <label>Número de factura<span>*</span></label>
            <input class="form-control" v-validate="'required'" type="text" v-model="billNumber" name="billNumber" data-vv-as="numero de factura"/>
            <span class="form-group-error">{{ errors.first('billNumber') }}</span>
        </div>
        <div class="form-group">
            <label>Monto total en dolares $ (El campo monto total en dólares debe ser numérico y contener puntos decimales.)<span>*</span></label>
            <input class="form-control" v-validate="'required|decimal'" type="text" v-model="amount" name="amount" data-vv-as="monto total"/>
            <span class="form-group-error">{{ errors.first('amount') }}</span>
        </div>
        <div class="form-group">
            <label>Artículos</label>        
            <select id="products" name="products" v-model="productSelected" v-on:change="onChangeProduct()" >        
                <option value="">Seleccione un artículo</option>                            
                <option v-for="product in products" :value="product.label" :key="product.label">
                {{product.label}}
                </option>
            </select>
        </div>
        <div class="form-group">
            <label>Descripción<span>*</span></label>
            <input class="form-control" v-validate="'required'" type="text" v-model="getDescriptions" v-show="false"  name="description" data-vv-as="descripción"/>
            <input-tag class="form-control" :tags.sync="descriptions" :allowDuplicates="false"></input-tag>
            <span>*Las descripciones de los art&iacute;culos son obligatorios sino las encuentra en la lista de arriba por favor digitarlas</span>
            <span class="form-group-error">{{ errors.first('description') }}</span>
        </div>
        <div class="form-group">
            <label>Subir archivo</label>
            <input v-validate="'ext:jpeg,jpg,gif,png,pdf'" type="file" id="invoice" ref="invoice" @change="processFile" data-vv-as="factura" name="invoice" accept="image/jpeg,image/gif,image/png,application/pdf"/>
            <span>Solo se permiten imagenes y PDF</span>
            <span class="form-group-error">{{ errors.first('invoice') }}</span>
        </div>
        <div>
            <ckeditor :editor="editor" v-model="text" :config="editorConfig"></ckeditor>
        </div>
        <div>
            <button class="save-bill-button" v-on:click="savePurchaseBill">Guardar</button>
        </div>
    </div>
    <div class="bills-modal" v-else >
        <h1>Factura Presentada</h1>
        <iframe id='iframe-bill' width='100%' height='500' :src="fileLocationURL"></iframe>
        <div>
            <ckeditor v-model="text" :disabled="true" :editor="editor" :config="editorConfig"></ckeditor>
        </div>
        <div class="buttons-bill-container flex-row">
            <button v-on:click="$emit('close')">OK</button>
            <button v-on:click="deletePurchaseBill">Borrar Factura</button>
        </div>
    </div>
</template>

<script>

import Products from '../../services/articulos.json'
import InputTag from 'vue-input-tag'
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import * as CrboxApi from '../../services/CrboxApi.js'

export default {
    name: 'bills-modal',
    data () {
        return {
            billNumber: "",
            amount: "",
            text: "",
            products: Products,
            productSelected: {},
            descriptions: [],
            file: {},
            editor: ClassicEditor,
            editorConfig: {
                htmlSupport: {
                    allow: [
                        {
                            name: /.*/,
                            attributes: true,
                            classes: true,
                            styles: true
                        }
                    ]
                },
                htmlEmbed: {
                    showPreviews: true
                },
                mediaEmbed: {
                    previewsInData: true
                },
                extraPlugins: [ 'PasteFromOffice', 'Autoformat', 'Image', 'Link' ],
                pasteFromOffice: {
                    removeStyles: false
                },
            },
        }
    },
    props: {
        mode: String,
        warehouseId: Number
    },
    components: {
        InputTag,
    },
    mounted() {
        if(this.mode != "new" && this.warehouseId != undefined){
            CrboxApi.getPurchaseBills(this,this.warehouseId)
            .then((response)=>{
                this.file = response.data[0]
                this.text = this.file.FileTextContent
            })
        }
    },
    methods: {
        savePurchaseBill: function (){
            var _this = this
            this.$validator.validate().then(result => {
                if (result) {
                    if(_this.file.name == undefined && _this.text == ""){ //it needs a file or text
                        this.$notify({
                            group: 'notifications',
                            type: 'warn',
                            title: 'Factura',
                            text: "Debe adjuntar una factura",
                            duration: 4000,
                            speed: 1000
                        })
                    }else{
                        var callbackCreatePurchaseBill = (response) => {
                            if(response.data.StatusResult == "OK"){
                                this.$notify({
                                    group: 'notifications',
                                    type: 'success',
                                    title: 'Factura almacenada',
                                    text: response.data.Message,
                                    duration: 4000,
                                    speed: 1000
                                })
                                this.$parent.$parent.$parent.searchPackages() //recarga vista de paquetes
                                this.$emit('close')

                            }else if(response.data.StatusResult == "FALSE"){
                                this.$notify({
                                    group: 'notifications',
                                    type: 'error',
                                    title: 'Factura',
                                    text: response.data.Message,
                                    duration: 4000,
                                    speed: 1000
                                })
                            }
                        }
                        if(_this.file.name != undefined){ //caso con archivo
                            this.uploadFile()
                            .then((response) => {
                                if(response.data.url != undefined){
                                    var fileUrl = response.data.url
                                    CrboxApi.postCreatePurchaseBill(this, this.warehouseId, this.text, this.billNumber, this.getDescriptions, this.amount, fileUrl)
                                    .then(callbackCreatePurchaseBill)
                                }else{
                                    this.$notify({
                                        group: 'notifications',
                                        type: 'error',
                                        title: 'Factura',
                                        text: "Error al almacenar la factura",
                                        duration: 4000,
                                        speed: 1000
                                    })
                                }
                            })                           
                        }else{ // Solo text
                            var fileUrl = ""
                            CrboxApi.postCreatePurchaseBill(this, this.warehouseId, this.text, this.billNumber, this.getDescriptions, this.amount, fileUrl)
                            .then(callbackCreatePurchaseBill)
                        }                  
                    }
                }
            });
        },
        deletePurchaseBill: function() {
            CrboxApi.deletePurchaseBill(this,this.warehouseId,this.$auth.user().email)
            .then((response)=>{
                if(response.data.StatusResult == "OK"){
                    this.$notify({
                        group: 'notifications',
                        type: 'success',
                        title: 'La factura',
                        text: "La factura ha sido borrada",
                        duration: 4000,
                        speed: 1000
                    })
                    this.$parent.$parent.$parent.searchPackages() //recarga vista de paquetes
                    this.$emit('close')
                }else if(response.data.StatusResult == "False"){
                    this.$notify({
                        group: 'notifications',
                        type: 'error',
                        title: 'Factura',
                        text: response.data.Message,
                        duration: 4000,
                        speed: 1000
                    })
                }else{
                    this.$notify({
                        group: 'notifications',
                        type: 'error',
                        title: 'Factura',
                        text: "Ocurrió un error al borrar la factura",
                        duration: 4000,
                        speed: 1000
                    })
                }
            })
        },
        uploadFile: function (){ //TODO
            var form = new FormData()
            form.append("email", this.$auth.user().email)
            form.append("invoice", this.file)
            form.append("wr_id", this.warehouseId)
            return this.$http.post(window.location.origin + '/wp-json/crbox/v1/saveBill', form,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
        },
        processFile: function(){
            this.file = this.$refs.invoice.files[0]
        },
        onChangeProduct: function(){
            if(this.descriptions.indexOf(this.productSelected) == -1 && this.productSelected != "")
                this.descriptions.push(this.productSelected)
        }
    },
    computed: {
        getDescriptions: function(){
            return this.descriptions.join(", ")
        },
        fileLocationURL(){
            if(this.file.FileLocation) return this.file.FileLocation.replace("https:","").replace("http:","")
            return ""
        }
    }
}
</script>